import IIndexable from "@/utils/types/IIndexable";

export const currencyImages: IIndexable<string> = {
  btc: "btc",
  eth: "eth",
  trc20: "usdt",
  erc20: "usdt",
  usdt: "usdt",
  tronusdt: "usdt",
  bnb: "bnb",
};

export const statusClassNames: IIndexable<string> = {
  pool: "blue blue--text",
  pending: "orange orange--text",
  approved: "green green--text",
  reported: "red red--text",
};
